export default "__VITE_ASSET__93a76249__"